var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5269 0.0135764L0.179666 4.13033C0.12911 4.14714 0.0848678 4.17894 0.0528161 4.22149C0.0207643 4.26405 0.00242114 4.31535 0.000223492 4.36859C-0.00197416 4.42182 0.0120779 4.47446 0.0405126 4.51951C0.0689473 4.56457 0.110418 4.5999 0.159416 4.62083L4.69692 6.56558C4.72069 6.57587 4.74673 6.57983 4.77249 6.57707C4.79825 6.57431 4.82286 6.56492 4.84392 6.54983L9.29217 3.37133C9.43017 3.27383 9.59967 3.44333 9.50216 3.58133L6.32367 8.02958C6.30882 8.05062 6.29965 8.07512 6.29702 8.10074C6.29439 8.12635 6.2984 8.15221 6.30867 8.17583L8.25267 12.7133C8.27352 12.7623 8.30879 12.8039 8.3538 12.8324C8.39881 12.8609 8.45142 12.875 8.50465 12.8729C8.55787 12.8707 8.6092 12.8525 8.6518 12.8205C8.6944 12.7885 8.72627 12.7443 8.74317 12.6938L12.8599 0.345826C12.8754 0.299545 12.8777 0.24986 12.8665 0.202352C12.8553 0.154845 12.8311 0.111396 12.7966 0.0768846C12.7621 0.0423735 12.7186 0.018167 12.6711 0.00698388C12.6236 -0.00419926 12.5732 -0.00191631 12.5269 0.0135764Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7b12b8fb18d7da5921759c0db6a626fd.svg";
export { ForwardRef as ReactComponent };